import { authApi } from '@/features/auth/auth.api.ts'
import { authPersistenceMiddleware } from '@/features/auth/auth.middleware.ts'
import { documentAutofillApi } from '@/features/document-autofill/document-autofill.api.ts'
import { checklistApi } from '@/features/checklist/checklist.api.ts';
import { headcountApi } from '@/features/headcount/headcount.api.ts'
import { portalConfigurationApi } from '@/features/portal-configuration/portal-configuration.api.ts'
import { appraisalApi } from '@/features/appraisal/appraisal.api.ts'
import { userApi } from '@/features/user/user.api.ts'
import { unauthorizedMiddleware } from '@/redux/unauthorized.middleware.ts'
import { employeeDataApi } from '@/features/employee-data/employee-data.api.ts'
import { rewardExerciseApi } from '@/features/reward-exercise/reward-exercise.api.ts'
import { timeOffApi } from '@/features/time-off/time-off.api.ts'
import { enumApi } from '@/features/employee-data/enumApi.ts'
import { onboardingApi } from '@/features/onboarding/onboarding.api.ts'
import { offboardingApi } from "@/features/offboarding/offboarding.api.ts";
import { probationApi } from '@/features/probation/probation.api.ts'
import { promotionApi } from '@/features/promotion/promotion.api.ts'
import { overtimeApi } from '@/features/overtime/overtime.api.ts'
import { teamApi } from '@/features/team/team.api.ts'

export const extraMiddleware = [
  authPersistenceMiddleware,
  unauthorizedMiddleware,
  authApi.middleware,
  documentAutofillApi.middleware,
  employeeDataApi.middleware,
  checklistApi.middleware,
  appraisalApi.middleware,
  headcountApi.middleware,
  portalConfigurationApi.middleware,
  userApi.middleware,
  rewardExerciseApi.middleware,
  timeOffApi.middleware,
  enumApi.middleware,
  onboardingApi.middleware,
  offboardingApi.middleware,
  probationApi.middleware,
  promotionApi.middleware,
  overtimeApi.middleware,
  teamApi.middleware,
]
